import { Component, OnInit } from '@angular/core';
import { TourNavigationService } from '../services/tour-navigation.service';
import { TourService } from '../services/tour.service';
import { Steps } from '../shared/steps-model';
import { EngineService } from '../services/engine.service';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';

@Component({
  selector: 'app-tab-panel',
  templateUrl: './tab-panel.component.html',
  styleUrls: ['./tab-panel.component.scss']
})
export class TabPanelComponent implements OnInit {
  tourStep: number;
  currentStep: number;
  menuStep1: any = {
    step1: true,
    editShape: false,
    editDeck: false,
    setHeight: false,
    addTiers: false,
    addStairs: false,
    addWall: false,
    addDoorsWindows: false,
    addAwnings: false,
    addTrellis: false,
    addAccessories: false,
    setScenery: false
  };
  menuStep2: any = {
    step2: true,
    editRailingType: false,
    editPostMounting: false,
    editCornerPosts: false,
    editRailingHeight: false,
    editTopRail: false,
    editInfill: false,
    addStairHandrail: false,
    addGates: false,
    addLighting: false,
    addPostCaps: false,
    editRailingColors: false,
    // dock mode: accessories are reachable from the railing step too
    addAccessories: false
  };

  constructor(
    public tourNavigationService: TourNavigationService,
    private vfTour: TourService,
    private engineService: EngineService,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService
  ) {}

  ngOnInit() {
    this.tourNavigationService.Navigator.subscribe(value => {
      this.tourStep = value;
    });

    this.vfTour.showCurrentStep.subscribe((stepItem: Steps) => {
      if (stepItem.step === 2) {
        setTimeout(function() {
          (<any>$('#step_1')).removeClass('active');
        }, 0);
      }
      this.tourStep = stepItem.step;
    });

    this.vfTour.resetTour.subscribe(value => (this.tourStep = value));
    this.dataForDisplayingMenuItemsService.setStep.subscribe(value => {
      this.currentStep = value;
    });
    this.dataForDisplayingMenuItemsService.startNewProj.subscribe(() => {
      setTimeout(function() {
        (<any>$('#step_2')).removeClass('active');
      }, 0);
      setTimeout(function() {
        (<any>$('#step_3')).removeClass('active');
      }, 0);
      setTimeout(function() {
        (<any>$('#step_1')).addClass('active');
      }, 0);
      this.displayDefault();
    });
  }

  displayChangeToStep1(subItem) {
    // console.log(subItem);
    for (const key in this.menuStep1) {
      if (this.menuStep1.hasOwnProperty(key)) {
        this.menuStep1[key] = false;
      }
    }
    this.menuStep1[subItem.name] = true;
    this.engineService.setActiveTabState(subItem.name);
  }

  displayChangeToStep2(subItem) {
    // console.log(subItem);
    for (const key in this.menuStep2) {
      if (this.menuStep2.hasOwnProperty(key)) {
        this.menuStep2[key] = false;
      }
    }
    this.menuStep2[subItem.name] = true;
    this.engineService.setActiveTabState(subItem.name);
  }

  displayDefault() {
    for (const item in this.menuStep1) {
      this.menuStep1[item] = false;
    }
    for (const item in this.menuStep2) {
      this.menuStep2[item] = false;
    }
    this.menuStep1.step1 = true;
    this.menuStep2.step2 = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/tab-panel/tab-panel.component.ts